import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const stats = [
  { label: "成立年份", value: siteInfo.founded, icon: "ri-flag-line" },
  { label: "合作机构", value: siteInfo.partnerCount, icon: "ri-links-line" },
  { label: "资源收录", value: siteInfo.resourceCount, icon: "ri-archive-2-line" },
  { label: "累计访问", value: siteInfo.visitCount, icon: "ri-eye-line" },
];

export default function SiteIntro() {
  return (
    <section className="bg-primary-900 px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="flex flex-col gap-5">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-400">
              <span className="w-5 h-px bg-accent-400" />
              关于本站
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold leading-snug text-background-50">
              一个更懂检索的品牌信息门户
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-primary-200">
              {siteInfo.intro}
            </p>
            <p className="text-sm leading-relaxed text-primary-300">
              我们相信，清晰的信息结构本身就是一种尊重。无论你是初次了解品牌的普通用户，还是需要查阅资料的行业伙伴，都能在这里快速找到所需内容。
            </p>
            <Link
              to="/about"
              className="inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
            >
              了解我们的故事
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="flex flex-col gap-3 rounded-lg border border-primary-700 bg-primary-800/60 p-5"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-md bg-accent-500/15 text-accent-400">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-semibold text-background-50">
                  {item.value}
                </span>
                <span className="text-xs text-primary-300">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}